<template>
  <div v-if="this.$route.query.type == 'edit'" >
    <router-view/>
  </div>
  <div v-else class="faq">
	<Modal
	  v-model="modalEditImage"
	  title="替换图片"
	  :closable="false"
	  :mask-closable="false"
	>
	  <p>图片：{{upload_image_name}}</p>
      <div v-if="addCheckImages!=''"><span>资源状态：</span><span style="color: red;">{{addCheckImages}}</span></div>
	  <Upload action="" :before-upload="(file) =>  { return addImgRecord(file, 0)}" accept =".png" :multiple="true">
	      <Button icon="ios-cloud-upload-outline">上传图片</Button>
	  </Upload>
      <div slot="footer" align="right">
        <Button class="btn" size="default" type="default" @click="editRecordCancel">取消</Button>
        <Button class="btn" size="default" type="primary" @click="editRecordImage">确定</Button>
      </div>
	</Modal>
    <Modal
      v-model="modalAdd"
      title="新增商品"
      :closable="false"
      :mask-closable="false"
      
    >
      <p>类型：</p>
      <Select v-model="addClassify" filterable>
        <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
	  <p>图片：{{upload_image_name}}</p>
      <div v-if="addCheckImages!=''"><span>资源状态：</span><span style="color: red;">{{addCheckImages}}</span></div>
	  <Upload action="" :before-upload="(file) =>  { return addImgRecord(file, 0)}" accept =".png" :multiple="true">
	      <Button icon="ios-cloud-upload-outline">上传图片</Button>
	  </Upload>
      <p>用钻价格：</p>
      <Input v-model="addJewelPrice" placeholder="请输入用钻价格" clearable />
      <p>用币价格：</p>
      <Input v-model="addCoinPrice" placeholder="请输入用币价格" clearable />
      <p>状态：</p>
      <Select v-model="addStatus" filterable>
        <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <!-- <Checkbox v-model="isUpdateTime">是否更新时间</Checkbox> -->
      <p>备注：用钻购买价格，-1为不可用钻购买；用币购买价格，-1为不可用币购买</p>
        <div slot="footer" align="right">
                <Button class="btn" size="default" type="default" @click="addRecordCancel">取消</Button>
                <Button class="btn" size="default" type="primary" @click="addRecord">确定</Button>
        </div>

    </Modal>
    <div class="headers">
      <span>分类：</span>
      <Select @on-change="changeSelect" v-model="classify" style="width: 110px">
        <Option
          v-for="item in filterClassify"
          :value="item.value"
          :key="item.value"
        >{{ item.label }}</Option>
      </Select>
      <Button @click="modalAdd = true">新增</Button>
      <Button @click="getRecords">刷新</Button>
    </div>
    <Table :columns="columns" :data="data">
      <template slot-scope="{ row, index }" slot="id">
        <span>{{ row.id }}</span>
      </template>
		<template slot-scope="{ row, index }" slot="url">
		    <Poptip trigger="hover" :transfer="true" title="图片详情">
		        <div class="info-pop" slot="content">
		            <img :src="row.url">
		        </div>
		        <img :src="row.url" style="width: 50px;height: 50px;">
		    </Poptip>
		</template>
      <template slot-scope="{ row, index }" slot="priority">
        <span>{{ row.priority }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="category_id">
        <template v-if="editIndex === index">
          <Select v-model="updateClassify" filterable>
            <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.category_id|getClassify }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="images">
        <template v-if="editIndex === index">
          <Input type="textarea" :autosize="{minRows: 3}" v-model="updateImages" placeholder="请输入图片名称，回车输入下一个" clearable/>
        </template>
        <span class="images-text" v-else>{{ row.images }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="jewel_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateJewelPrice" />
        </template>
        <span v-else>{{ row.jewel_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="coin_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateCoinPrice" />
        </template>
        <span v-else>{{ row.coin_price }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="status">
        <template v-if="editIndex === index">
          <Select v-model="updateStatus" filterable>
            <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.status|getStatus }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <div v-if="!sorting">
          <div v-if="editIndex === index">
            <Button @click="handleSave(index)" :disabled="action_btn_disabled">保存</Button>
            <Button
              style="margin-left: 10px"
              @click="editIndex = -1"
              :disabled="action_btn_disabled"
            >取消</Button>
          </div>
          <div v-else>
            <Button @click="handleEdit(row, index)">修改</Button>
            <Button style="margin-left: 10px" @click="editImages(row, index)">替图</Button>
          </div>
        </div>
        <div v-else>
          <Button
            :disabled="index === 0"
            style="border-radius: 50%"
            @click="handel_sort(row,index,'up')"
          >上</Button>
          <Button
            :disabled="index === data.length -1"
            style="border-radius: 50%;margin-left: 5px"
            @click="handel_sort(row,index,'down')"
          >下</Button>
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import apis from "../../../http/api";
import OSS from 'ali-oss';

export default {
  name: "faq",
  data() {
    return {
	  ossClient: null,
	  upload_image_data:null,
	  upload_image_name:null,
	  
	  image_for_shop: false,
	  
      filterStatus: [{ label: '正常', value: 0 }, { label: '下架', value: -1 }, { label: '赠品', value: -2 }],
      filterClassify: [{ label: '墙漆', value: 1 }, { label: '墙纸', value: 2 }, { label: '地板', value: 3 },
        { label: '左侧柜子', value: 4 }, { label: '徽章架', value: 5 }, { label: '软装', value: 6 },
        { label: '挂饰', value: 7 }, { label: '左右墙', value: 8 }],
      classify: 1,
      room_type: 0,   // 0 家
      data: [],
      tmpData: [],
      modalAdd: false,
	  modalEditImage: false,
      action_btn_disabled: false,
      sortSaveBtn: false,
      update_question: "",
      update_answer: "",
      update_faq_id: null,
      editIndex: -1,
      sorting: false,
      sortBtnDesc: "排序",
      addClassify: 1,
      addImages: "",
      addCheckImages:"",
      addJewelPrice: null,
      addCoinPrice: null,
      addStatus: 0,
      updateClassify:'',
      updateImages: "",
      updateDiscount: 0,
      updateJewelPrice: null,
      updateCoinPrice: null,
      updateStatus: 0,
	  updateTagsPropId: -1,
      onRequest:false,
      dictSize:{
          'shop':'200x200',
          'wallpaper':'4002x1125',
          'floor':'4002x408',
          'cabinet':'582x963',
          'cabinet_badge':'174x174',
          'cabinet_days':'174x174',
          'cabinet_wardrobe':'174x174',
          'cabinet_contacts':'174x174',
          'cabinet_diary':'174x174',
          'cabinet_lock':'174x174',
          'badge':'2001x426',
          'badge_header':'2001x648'
      },
      columns: [
		  {
		    title: '商品ID',
		    slot: 'id',
		    width: 0
		  },
		  {
		    title: '缩略图',
		    slot: 'url',
		    width: 0
		  },
        {
          title: '优先级',
          slot: 'priority',
          width: 80
        },
        {
          title: '类型',
          slot: 'category_id',
          // width: 120
        },
        {
          title: '图片',
          slot: 'images',
          width: 220
        },
        {
          title: '用钻价格',
          slot: 'jewel_price',
          // width: 170
        },
        {
          title: '用币价格',
          slot: 'coin_price',
          // width: 170
        },
        {
          title: '状态',
          slot: 'status',
          // width: 170
        },
        {
          title: '操作',
          slot: 'action',
          width: 270
        }
      ]
    }
  },
  async created() {
	this.getOss();
    await this.getRecords()
  },
  watch: {
    // 如果退出编辑将多选框置为false
    editIndex: function (newVal, oldVal) {
      if (newVal === -1) {
        this.isUpdateTime = false
      }
    },
    addClassify: function(newVal, oldVal){
        this.clearRecordInfo()
    },
    modalAdd: function (newVal, oldVal) {
      if (newVal) {
        this.addClassify = this.classify;
      }
    }
  },
  methods: {
	async getOss() {
	    apis.get_oss().then(res => {
	        this.ossClient = new OSS({
	            region: 'oss-cn-shanghai',
	            accessKeyId: res.AccessKeyId,
	            accessKeySecret: res.AccessKeySecret,
	            stsToken: res.SecurityToken,
	            bucket: 'co-study',
	        })
	    }).catch(err => {
	        console.log(err)
	    })
	},
	
	get_image_size_str(event) {
		let filename = ''
		return new Promise(function(resolve, reject) {
		                let _URL = window.URL || window.webkitURL;
		                let img = new Image();
		                img.onload = function() {
		                    filename =  '_' + img.width + '_' + img.height
							resolve()
		                }
		                img.src = _URL.createObjectURL(event);
		            }).then(() => {
		                return filename;
		            }, () => {
		                this.$message.error('!');
		                return Promise.reject();
		            });
	},
	
	async addImgRecord(event, type) {
	    try {
			let file_key = event.name.split('.')[0]
			let timestamp = Date.now()
			timestamp =  parseInt(timestamp/1000)
			
			let filename = this.$route.query.shop_id +'_'+ timestamp
			
			let tem = await this.get_image_size_str(event)
			var length = 0
			if (this.upload_image_data) {
				length = this.upload_image_data.length
			}
			filename = filename + '_' + length + tem + '.png'
			if (this.classify === null) {
			    this.$Message.error('请先选择类型');
			    return Promise.reject()
			}
			if (type == 0) {
				if (this.upload_image_name === null) {
					this.upload_image_name = ''
				}
				this.upload_image_name += event.name + '\n'
				if (this.upload_image_data === null) {
					this.upload_image_data = []
				}
				this.upload_image_data.push({'key':event.name.split('.')[0], 'filename':filename, 'data':event})
			}
	    } catch (e) {
	        console.log(e);
	        this.$Message.error('失败');
	    }
	    return Promise.reject()
	},
	async upload_image_to_oss(){
		let oss_url = 'app/image/furniturepersonal/'
		let result = null
		
		if (!this.upload_image_data) {
			console.log('no image')
			return true
		}else{
			console.log('start upload image')
		}
		for (let i = 0; i < this.upload_image_data.length; i++) {
			let tmp_dict = this.upload_image_data[i]
			console.log(tmp_dict['filename'])
			result = await this.ossClient.put(oss_url + tmp_dict['filename'], tmp_dict['data']);
			if (result.res.status === 200) {
				this.$Message.success('上传成功');
			} else {
				console.log(tmp_dict['key'])
			    return false
			}
		}
		return true
	},
    async getRecords() {
      let params = {
        'category_id': this.classify,
		'shop_id': this.$route.query.shop_id
      }
      apis.furniture_personal_centre_shop_by_category(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.data = data.records
        }
      }).catch(err => {

      })
    },
	async editRecordImage() {
        
        if(!await this.check_upload_images()){
            this.$Message.error('图片资源异常');
            return
        }
		let upload_result = await this.upload_image_to_oss()
		if (!upload_result) {
				  this.$Message.error('图片上传失败');
				  return
		}
		var images_dict = {}
		if (this.upload_image_data) {
				  for (let i = 0; i < this.upload_image_data.length; i++) {
				  	let tmp_dict = this.upload_image_data[i]
				  		images_dict[tmp_dict['key']] = tmp_dict['filename']
				  }
		}
        this.clearRecordInfo()
        if(this.onRequest){
            return
        }
        this.onRequest = true
		let post_data = {
		  images: JSON.stringify(images_dict),
		  furniture_id: this.updateTagsPropId
		}
		console.log(post_data)
		await apis.furniture_personal_shop_update_record_json(post_data).then(res => {
		  const { data, errCode, msg } = res;
		  if (errCode !== 0){
		    this.$Message.error(msg);
		  }
		})
        this.onRequest = false
        this.modalEditImage= false
        await this.getRecords()
	},
    editRecordCancel(){
        this.clearRecordInfo()
        this.modalEditImage = false
    },
    addRecordCancel(){
        this.clearRecordInfo()
        this.modalAdd = false
    },
    clearRecordInfo(){
        this.upload_image_data = null
        this.upload_image_name = null
        this.addCheckImages = ''
    },
    // 检测资源是否合规
    async check_upload_images(){
       let fileCount = this.upload_image_data.length
       if(this.addClassify === 1){
           this.addCheckImages = '墙漆不可新增，需手动录入数据库'
           return false
       }else if(this.addClassify === 2){
           // 墙纸
           return await this.checkImageCountAndName(fileCount,['shop','wallpaper'])
       }else if(this.addClassify === 3){
           // 地板
           return await this.checkImageCountAndName(fileCount,['shop','floor'])
       }else if(this.addClassify === 4){
           // 左侧柜子
           return await this.checkImageCountAndName(fileCount,['shop','cabinet','cabinet_badge','cabinet_days','cabinet_wardrobe','cabinet_contacts','cabinet_diary','cabinet_lock'])
       }else if(this.addClassify === 5){
           // 徽章架
           return await this.checkImageCountAndName(fileCount,['shop','badge','badge_header'])
       }else if(this.addClassify === 6 || this.addClassify === 7 || this.addClassify === 8){
           // 软装、挂饰、左右墙挂饰
           return await this.checkImageCountAndName(fileCount,['shop','wall'])
       }
       return true
    },
    async checkImageCountAndName(fileCount,keys){
        if(fileCount != keys.length){
            this.addCheckImages = '需要资源共'+keys.length+'张，目前为'+fileCount+'张'
            return false
        }
        let error = ''
        let sizeError = ''
        for (let i = 0; i < this.upload_image_data.length; i++) {
            let tmp_dict = this.upload_image_data[i]
            let tmp_key = tmp_dict['key']
            console.log(tmp_dict['filename']+',key = '+tmp_dict['key'])
            if (!keys.find(item => item===tmp_key)) {
                if(error!=''){
                    error += '，'+tmp_key + ".png" 
                }else{
                    error += tmp_key + ".png" 
                }
            }else{
                let currentSize = this.dictSize[tmp_key]
                if(currentSize != undefined){
                    let filename = tmp_dict['filename'].split('.')[0]
                    let fileSize = filename.split('_')[3]+'x'+filename.split('_')[4]
                    if(currentSize != fileSize ){
                        if(error!=''){
                            sizeError += '，['+tmp_key + ".png ，"+currentSize+'，'+fileSize+"]" 
                        }else{
                            sizeError += '['+tmp_key + ".png ，"+currentSize+'，'+fileSize+"]" 
                        }
                    }
                    console.log("文件名 = "+tmp_key+','+tmp_dict['filename']+','+fileSize)
                }else{
                     console.log("文件名不需要检测 = "+tmp_key +','+ tmp_dict['filename'])
                }

            }
        }
        if(error!='' || sizeError !=''){
            this.addCheckImages ='图片名称错误 = ' + error +'\n 图片尺寸错误 = '+sizeError
            return false
        }
        return true
    },
    async addRecord() {
    
      if(!await this.check_upload_images()){
          this.$Message.error('图片资源异常');
          return
      }
      if (!this.addJewelPrice) {
        this.$Message.error('钻价格不能为空');
        return
      }
      if (!this.addCoinPrice) {
        this.$Message.error('币价格不能为空');
        return
      }
	  var images_dict = {}
	  if(this.addClassify === 0){
	  		  console.log('updaload_', this.addClassify)
	  }else{
	  		  console.log('上传图片ing')
	  		  let upload_result = await this.upload_image_to_oss()
	  		  if (!upload_result) {
	  		  		  this.$Message.error('图片上传失败');
	  		  		  return
	  		  }
	  }
	  if (this.upload_image_data) {
		  for (let i = 0; i < this.upload_image_data.length; i++) {
		  	let tmp_dict = this.upload_image_data[i]
		  		images_dict[tmp_dict['key']] = tmp_dict['filename']
		  }
	  }
      this.clearRecordInfo()
	  
	  // console.log(images_dict)
	  if(this.onRequest){
	      return
	  }
	  this.onRequest = true
	  this.addImages = JSON.stringify(images_dict)
      let post_data = {
        category_id: this.addClassify,
        images: this.addImages,
        jewel_price: this.addJewelPrice,
        coin_price: this.addCoinPrice,
        status: this.addStatus,
		shop_id: this.$route.query.shop_id,
      }
	  console.log(post_data)
      await apis.furniture_personal_centre_shop_upload(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.addImages = ""
          this.addJewelPrice = null
          this.addCoinPrice = null
        }else {
          this.$Message.error(msg);
        }
      }).catch(res => {
        this.$Message.error(res.toString());
      })
      this.onRequest = false
      this.modalAdd = false
      await this.getRecords()
    },
    updateRecord(index) {
      if (!this.updateImages) {
        this.$Message.error('图片不能为空');
        return
      }
      if (!this.updateJewelPrice) {
        this.$Message.error('钻价格不能为空');
        return
      }
      if (!this.updateCoinPrice) {
        this.$Message.error('币价格不能为空');
        return
      }
      let beforeCategoryId = this.data[index].category_id
      if(this.updateClassify != beforeCategoryId){
          // 当用户已经购买的情况下切换会导致异常
          this.$Message.error('分类之间不可切换');
          return
          // if(beforeCategoryId <= 5){
          //     this.$Message.error('分类只可在软装、挂饰、左右墙之间切换');
          //     return
          // }
          // if(beforeCategoryId>5 && beforeCategoryId<=8 && this.updateClassify>5 && this.updateClassify<=8){
              
          // }else{
          //     this.$Message.error('分类只可在软装、挂饰、左右墙之间切换');
          //     return
          // }
          
      }
      let post_data = {
        id: this.data[index].id,
        category_id: this.updateClassify,
        images: this.updateImages,
        jewel_price: this.updateJewelPrice,
        coin_price: this.updateCoinPrice,
        discount: this.updateDiscount,
        status: this.updateStatus,
      }
      apis.furniture_personal_shop_update_record(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode !== 0){
          this.$Message.error(msg);
        }
        this.getRecords()
      })
    },
	editImages(row, index) {
		console.log(row, index)
        this.addClassify = row.category_id
		this.updateTagsPropId = row.id
		this.modalEditImage=true
	},
    handleEdit(row, index) {
      this.action_btn_disabled = false;
      this.updateClassify = row.category_id;
      console.log(row.classify);
      this.updateImages = row.images;
      console.log(row.room_type)
      this.updateDiscount = row.discount;
      this.updateJewelPrice = row.jewel_price;
      this.updateCoinPrice = row.coin_price;
      this.updateStatus = row.status;
      console.log(row.status)
      this.editIndex = index;
    },
    handleSave(index) {
      this.action_btn_disabled = true;
      this.updateRecord(index);
      this.editIndex = -1;
    },
    sort_btn() {
      this.sorting = !this.sorting
      this.sortSaveBtn = !this.sortSaveBtn
      if (!this.sorting) {
        // 深拷贝
        let tmp = JSON.stringify(this.tmpData)
        this.data = JSON.parse(tmp)
      } else {
        // 深拷贝
        let tmp = JSON.stringify(this.data)
        this.tmpData = JSON.parse(tmp)
      }
    },
    handel_sort(row, index, action) {
      let index2 = action === "up" ? index - 1 : index + 1;
      let index1 = index;
      // 将当前位置的值取出来替换为另一个值并将当前取出来的值赋给另一个值
      this.data[index1] = this.data.splice(index2, 1, this.data[index1])[0]
    },
    sort_save() {
      this.sorting = !this.sorting
      this.sortSaveBtn = !this.sortSaveBtn
      let post_data = {
        records: this.data,
        classify: this.classify,
      }
      // apis.image_shop_sort_records(post_data).then(res => {
      //   const { data, errCode, msg } = res;
      //   if (errCode === 0) {
      //     this.getRecords()
      //   }
      // })
    },
    async changeSelect() {
      await this.getRecords()
    }
  },
  computed: {
    sort_btn_msg() {
      return this.sorting ? "取消" : "排序"
    }
  },
  filters:{
    getClassify(val){
      let categoryClassifyMap = {1: '墙漆', 2: '墙纸', 3: '地板', 4: '左侧柜子', 5: '徽章架', 6: '软装', 7: '挂饰', 8: '左右墙'}
      return categoryClassifyMap[val]
    },
    getStatus(val) {
      if(val === 0){
        return '正常'
      }else if(val === -1){
        return '下架'
      } else if(val === -2){
        return '赠品'
      } else {
        return '异常'
      }
    },
	getTags(val) {
	  if(val === ""){
	    return '暂无'
	  }else {
	    return val
	  }
	},
	getTagsEdit(val) {
	  if(val === ""){
	    return '暂无'
	  }else {
	    return "\n\n\n\n\n\n" + val +"\n\n\n\n\n\n"
	  }
	}
  }
}
</script>

<style lang="stylus" scoped>
.faq /deep/ .ivu-table-cell {
  min-height: 33px;
  display: flex;
  justify-content center;
  align-items: center;
}

.faq {
  margin: 10px;
}

.headers {
  text-align: center;
  margin-bottom: 10px;
}

.headers button {
  margin-left: 10px;
}

.images-text {
  white-space: pre-wrap;
}

</style>